/*
 * @Author: living hell
 * @Date: 2024-09-30 14:45:52
 * @LastEditors: liuchao lc19990308@163.com
 * @LastEditTime: 2024-09-30 15:10:35
 * @FilePath: /vue2-template/src/router/index.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    redirect: "/layout/HomePage",
  },
  {
    path: "/layout",
    redirect: "/layout/HomePage",
    name: "layout",
    component: () => import("../layout/Layout.vue"),
    children: [
      {
        path: "HomePage",
        name: "HomePage",
        meta: {
          login: false,
        },
        component: () => import("../views/home/HomePage.vue"),
      },
      {
        path: "DocumentPage",
        name: "DocumentPage",
        meta: {
          login: false,
        },
        component: () => import("../views/document/DocumentPage.vue"),
      },
      {
        path: "ApiPage",
        name: "ApiPage",
        meta: {
          login: true,
        },
        component: () => import("../views/api/ApiPage.vue"),
      },
      {
        path: "MyApi",
        name: "MyApi",
        meta: {
          login: true,
        },
        component: () => import("../views/api/MyApi.vue"),
      },
      {
        path: "ApplicationList",
        name: "ApplicationList",
        meta: {
          login: true,
        },
        component: () => import("../views/application/ApplicationList.vue"),
      },
      {
        path: "PayApplication",
        name: "PayApplication",
        meta: {
          login: true,
        },
        component: () => import("../views/application/PayApplication.vue"),
      },
      {
        path: "RecordsCenter",
        name: "RecordsCenter",
        meta: {
          login: false,
        },
        component: () => import("../views/recordsCenter/RecordsCenter.vue"),
      },
      {
        path: "UserCenter",
        name: "UserCenter",
        meta: {
          login: true,
        },
        component: () => import("../views/userCenter/UserCenter.vue"),
      },
      {
        path: "ExpenseCenter",
        name: "ExpenseCenter",
        meta: {
          login: false,
        },
        component: () => import("../views/expenseCenter/ExpenseCenter.vue"),
      },
      {
        path: "LoginPage",
        name: "LoginPage",
        meta: {
          login: false,
        },
        component: () => import("../views/login/LoginPage.vue"),
      },
      {
        path: "RegisterPage",
        name: "RegisterPage",
        meta: {
          login: false,
        },
        component: () => import("../views/login/RegisterPage.vue"),
      },
      {
        path: "DepartmentList",
        name: "DepartmentList",
        meta: {
          login: false,
        },
        component: () => import("../views/department/DepartmentList.vue"),
      },
      {
        path: "JobList",
        name: "JobList",
        meta: {
          login: false,
        },
        component: () => import("../views/department/JobList.vue"),
      },
      {
        path: "UserList",
        name: "UserList",
        meta: {
          login: false,
        },
        component: () => import("../views/user/UserList.vue"),
      },
      {
        path: "RoleList",
        name: "RoleList",
        meta: {
          login: false,
        },
        component: () => import("../views/role/roleList.vue"),
      },
      {
        path: "GlobalList",
        name: "GlobalList",
        meta: {
          login: false,
        },
        component: () => import("../views/info/GlobalList.vue"),
      },
      {
        path: "RegionList",
        name: "RegionList",
        meta: {
          login: false,
        },
        component: () => import("../views/info/RegionList.vue"),
      },
      {
        path: "menuList",
        name: "menuList",
        meta: {
          login: false,
          title: '菜单列表'
        },
        component: () => import("../views/menuList/indexPage.vue"),
      },
      {
        path: "system",
        name: "system",
        meta: {
          login: false,
          title: '系统管理'
        },
        component: () => import("../views/system/indexPage.vue"),
      },
      {
        path: "tenant",
        name: "tenant",
        meta: {
          login: false,
          title: '租户列表'
        },
        component: () => import("../views/tenant/tenantList.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});
const whiteList = ["/layout/LoginPage", "/layout/RegisterPage"];
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("AUTH_TOKEN");
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }
  //检测是否去白名单
  if (whiteList.includes(to.path)) {
    if (token) {
      next(false);
    } else {
      next();
    }
  }else{
    if(to.meta.login){
      if(token){
        next();
      }else{
        next('/layout/LoginPage')
      }
    }else{
      next();
    }
  }
});
export default router;
